import {
  createReferralCode,
  fetchReferralBalance,
  fetchReferralBeneficiaries,
  fetchReferralCode,
  sendInviteFriend
} from "../../_rx/inviteFriend/actions";
import { Fragment, h } from "preact";
import { connect } from "react-redux";
import { Card } from "../../_common/layout";
import { t } from "../../_i18n";
import { useEffect, useState } from "preact/hooks";
import ButtonSpinner from "../../_common/components/buttons/buttonSpinner/buttonSpinner";
import './PromoInviteComponent.scss';
import { ButtonGhost, ButtonPrimary } from "../../_common/components/buttons/buttons";
import Banner from "../../_common/components/Banner";
import ExpandCard from "../../_common/components/ExpandCard/ExpandCard";
import { LANG_ES } from "../../constants";
import { isMobileAgent } from "../../_common/common";
import Badge from "../../_common/components/Badge";
import { toastService } from "../../_services/toast-service";

function PromoInviteComponent({referralCode, referralBalance, referralBeneficiaries, fetchReferralCode, fetchReferralBalance, fetchReferralBeneficiaries, createReferralCode}) {
  const [loading, setLoading] = useState(false);
  const linkTerms = "https://www.ilerna.es/es/content/bases-promociones-ilerna-online#toc-bases-legales-de-la-promocion-referidos-ilerna-online";
  const MONTHS_ES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

  const code = referralCode?.code;

  const bonusAmount = referralBalance?.total_balance ?? 0;
  const discounts = referralBalance?.discounts ?? [];

  const hasCode = !!code;

  const whatsappMessage = t('Hola, te paso mi código de descuento para matricularte en iLERNA: {code}. Introdúcelo cuando te matricules en www.ilerna.es').replace('{code}', code);
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`;

  const campaignDateFinished = formatDate(referralCode?.date_to);
  const maxUses = referralCode?.max_uses;
  const usesThisSemester =
    maxUses != null && referralBeneficiaries?.uses_left != null
      ? maxUses - referralBeneficiaries.uses_left
      : null;

  const showProgressBar = usesThisSemester != null;
  const totalUsersEnrolls = referralBeneficiaries?.beneficiaries.length;
  const totalUsed = referralBalance?.discounts
    ?.filter(discount => discount.status === 'used')
    .reduce((total, discount) => total + discount.amount, 0);

  const totalGenerated = referralBalance?.discounts
    ?.filter(discount => discount.status !== 'validating')
    .reduce((total, discount) => total + discount.amount, 0);

  const progress = (usesThisSemester / maxUses) * 100;

  const isMobile = isMobileAgent();

  const today = new Date();
  const year = today.getFullYear();

  const promoWeek150Start = new Date(year, 6, 20);
  const promoWeek150End = new Date(year, 6, 28, 23, 59, 59, 999);

  const promoWeek100TripStart = new Date(year, 6, 29);
  const promoWeek100TripEnd = new Date(year, 6, 31, 23, 59, 59, 999);

  const promoAugustTripStart = new Date(year, 7, 1);
  const promoAugustTripEnd = new Date(year, 7, 23, 23, 59, 59, 999);

  let promoContent;

  if (today >= promoWeek150Start && today <= promoWeek150End) {
    // 20-28 julio
    promoContent = {
      title: '¡Solo esta semana: consigue 150€ por amigo y gana un viaje de hasta 10.000€!',
      description:
        'Genera tu código personal y compártelo con quien quieras. Si un amigo lo usa para matricularse del 20 al 28 de julio:',
      bullets: [
        'Te llevas 150€ de descuento automáticamente en tu próximo pedido (en 15 días).',
        'Tu amigo también recibirá 150€ de descuento directo en su matrícula.',
        'Y además, como embajador, entras directo en el sorteo de un viaje valorado en hasta 10.000€.'
      ]
    };
  } else if (today >= promoWeek100TripStart && today <= promoWeek100TripEnd) {
    // 29-31 julio
    promoContent = {
      title: 'Consigue 100€ por amigo matriculado y gana un viaje de hasta 10.000€',
      description:
        'Genera tu código personal y compártelo con quien quieras. Si un amigo lo usa para matricularse hasta el 31 de julio:',
      bullets: [
        'Te llevas 100€ de descuento automáticamente en tu próximo pedido (en 15 días).',
        'Tu amigo también recibirá 100€ de descuento directo en su matrícula.',
        'Y además, como embajador, entras directo en el sorteo de un viaje valorado en hasta 10.000€.'
      ]
    };
  } else if (today >= promoAugustTripStart && today <= promoAugustTripEnd) {
    // 1 - 23 agosto
    promoContent = {
      title: '¡Consigue 100€ por amigo matriculado! Aún estás a tiempo de ganar un viaje de hasta 10.000€',
      description:
        'Genera tu código personal y compártelo con quien quieras. Si un amigo lo usa para matricularse hasta el 23 de agosto:',
      bullets: [
        'Te llevas 100€ de descuento automáticamente en tu próximo pedido (en 15 días).',
        'Tu amigo también recibirá 100€ de descuento directo en su matrícula.',
        'Y además, como embajador, entras directo en el sorteo de un viaje valorado en hasta 10.000€.'
      ]
    };
  } else {
    // Desde el 24 de agosto
    promoContent = {
      title: 'Consigue 50€ por cada amigo matriculado',
      description:
        'Genera tu código personal y compártelo con quien quieras. Cuando un amigo lo use al matricularse, se te aplicarán automáticamente 50€ de descuento en tu próximo pedido (en un plazo de 15 días). Además, tu amigo también tendrá 50€ de descuento directo en su matrícula.',
      bullets: null
    };
  }

  function formatDate(dateString) {
    if (!dateString) return '';
    const [datePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-');
    return `${day}-${month}-${year}`;
  }

  function formatDateHistory(dateString) {
    if (!dateString) return '';
    const [datePart] = dateString.split(' ');
    const [year, month] = datePart.split('-');
    return `${MONTHS_ES[parseInt(month, 10) - 1]} ${year}`;
  }

  async function handleGetCode() {
    setLoading(true);
    await createReferralCode();
    await fetchReferralBeneficiaries();
    setLoading(false);
  }

  async function handleCopyCode() {
    try {
      await navigator.clipboard.writeText(code);
      toastService.showToast({ message: t('Código copiado'), type: 'info' });
    } catch (err) {
      console.error('Error al copiar el código:', err);
    }
  }

  useEffect(() => {
    fetchReferralCode();
    fetchReferralBalance();
    fetchReferralBeneficiaries();
  }, [])

  return (
    <div class={`promo-invite ${isMobile ? 'm-top' : ''}`}>
      <Card smOnly={true} class={`${!isMobile ? 'promo-invite__card' : ''} p-x2-bottom`}>
        <h2 className='m-top promo-invite__title-highlight'> {t(promoContent.title)} </h2>
        <p class="m-bottom promo-invite__description">
          {t(promoContent.description)}
        </p>

        {promoContent.bullets && (
          <div class="doted-list">
            <ul class="m-bottom">
              {promoContent.bullets.map((bullet) => (
                <li>{t(bullet)}</li>
              ))}
            </ul>
          </div>
        )}

        {!hasCode ? (
          <ButtonGhost
            disabled={loading}
            onClick={handleGetCode}
            className='promo-invite__btn-code'
          >
            <i class="far fa-solid fa-gift"></i>
            {t('OBTENER MI CÓDIGO DE DESCUENTO')}
          </ButtonGhost>
        ) : (
          <Fragment>
            <div className="promo-invite__code-box m-bottom">
              <p className="promo-invite__code-title">
                <strong>{t('Tu código personal:')}</strong>
              </p>

              <div className="promo-invite__code-content">
                <div className="promo-invite__code">
                  <strong>{code}</strong>
                </div>

                <ButtonGhost
                  className="promo-invite__copy-btn"
                  onClick={handleCopyCode}
                >
                  <i className="far fa-copy"></i>
                  {t('Copiar')}
                </ButtonGhost>
              </div>

              {isMobile && hasCode && (
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="promo-invite__whatsapp-btn btn btn-primary">
                  <i class="fab fa-whatsapp"></i>
                  {t('Compartir código')}
                </a>
              )}

              { showProgressBar &&
                <div className="promo-invite__progress-section">
                  <div className="promo-invite__progress-header">
                    <span>{t('Usos este semestre')}</span>
                    <span>{usesThisSemester} de {maxUses}</span>
                  </div>

                  <div className="promo-invite__progress">
                    <div
                      className="promo-invite__progress-bar"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                </div>
              }
            </div>
            <Banner color="info" background="info" class="m-bottom-x2">
              <span> {t('Tus amigos tienen hasta el {campaignDateFinished} para matricularse con tu código. Deben introducirlo al matricularse por primera vez en iLERNA.').replace('{campaignDateFinished}', campaignDateFinished)}</span>
            </Banner>
          </Fragment>
        )}

        <ExpandCard
          className="promo-invite__bonus-box m-top m-bottom"
          expandable={discounts.length > 0}
          iconVisible={<i className="far fa-chevron-up expandcard-icon" />}
          iconHidden={<i className="far fa-chevron-down expandcard-icon" />}
          title={
            <div>
              <p className='promo-invite__bonus-box-amount'>
                <span class="higher"><strong> {bonusAmount}€ </strong></span>
                <span class="lower"> <strong>{t('disponibles')}</strong> </span>
              </p>
              {discounts.length == 0 ?
                <p className='promo-invite__bonus-box-label'>
                  {t('Comparte el código de descuento con tus amigos para conseguir bonos de descuento.')}
                </p>
              :
                <div className="promo-invite__bonus-box-subtitle">
                  {t('{totalGenerated}€ generados').replace('{totalGenerated}', totalGenerated)} - {t('{totalUsed}€ utilizados').replace('{totalUsed}', totalUsed)}
                </div>
              }
            </div>
          }
        >
          <div className="promo-invite__history">
            <div className="promo-invite__history-header">
              <span>{t('Historial de bonos')}</span>
              <span>{totalUsersEnrolls} {t('amigos matriculados')}</span>
            </div>

            {discounts.map(discount => (
              <div className="promo-invite__history-row">
                <div className="promo-invite__history-user">
                  <strong>{discount.referred_email}</strong>
                  <span class="date-history">{formatDateHistory(discount.date_to)}</span>
                </div>

                <div className="promo-invite__history-status">
                  { discount.status === 'validating' ? (
                    <span className="promo-invite__validating">
                      { discount.available_from && t('Bono disponible a partir del {date}').replace('{date}', formatDate(discount.available_from)) }
                      <span className="promo-invite__badge__disabled">
                        <Badge type="disabled"><strong>{t('Bono {amount}€').replace('{amount}', discount.amount)}</strong></Badge>
                      </span>
                    </span>
                  ) : (
                    <span className="promo-invite__badge">
                      <Badge type="bono-available"><strong> {t('Bono {amount}€').replace('{amount}', discount.amount)} </strong></Badge>
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </ExpandCard>
      </Card>
      <div class="m-top font-16 t-underline text-primary">
        <a href={linkTerms} target='_blank' rel='noopener noreferrer' className='promo-invite__terms-link m-top-half'>
          {t('Consulta las bases de la promoción')}
        </a>
      </div>
    </div>
  )

}


PromoInviteComponent = connect(
  ({inviteFriendStatus}) => ({
    referralCode: inviteFriendStatus.code,
    referralBalance: inviteFriendStatus.balance,
    referralBeneficiaries: inviteFriendStatus.beneficiaries
  }),
  {fetchReferralCode, fetchReferralBalance, fetchReferralBeneficiaries, createReferralCode})(PromoInviteComponent);

export default ({...rest}) => <PromoInviteComponent {...rest}/>
